const DEFAULT_PLATFORM_CONNECTION_GUIDE_URL = 'https://commercium.tawk.help/'

const PLATFORM_CONNECTION_GUIDE_URL_OVERRIDES: Record<string, string> = {
  COMMERCEHUB:
    'https://commercium-help.constacloud.com/article/how-to-connect-commercehub-account-to-commercium',
}

export function getPlatformConnectionGuideUrl(
  platformName: string | null | undefined,
  helpHref: string | null | undefined
): string {
  const key = (platformName ?? '').trim().toUpperCase()
  if (key && PLATFORM_CONNECTION_GUIDE_URL_OVERRIDES[key]) {
    return PLATFORM_CONNECTION_GUIDE_URL_OVERRIDES[key]
  }
  return helpHref?.trim() ? helpHref : DEFAULT_PLATFORM_CONNECTION_GUIDE_URL
}
